// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2kBvQ","name":"Header_name__32UkD","birthday":"Header_birthday__2OoRA","skeleton":"Header_skeleton__3SzXu"};